"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.getStatusTranslation = void 0;
var types_1 = require("../types");
var Localization_1 = __importDefault(require("../localization/Localization"));
var getStatusTranslation = function (status) {
    switch (status) {
        case types_1.IssuerStatus.VERIFIED:
            return Localization_1["default"].translate('issuer_status_verified');
        case types_1.IssuerStatus.UNVERIFIED:
            return Localization_1["default"].translate('issuer_status_unverified');
        case types_1.CredentialStatus.VALID:
            return Localization_1["default"].translate('credential_status_valid');
        case types_1.CredentialStatus.EXPIRED:
            return Localization_1["default"].translate('credential_status_expired');
        case types_1.CredentialStatus.REVOKED:
            return Localization_1["default"].translate('credential_status_revoked');
        case types_1.CredentialStatus.DRAFT:
            return Localization_1["default"].translate('credential_status_draft');
        case types_1.WorkflowStatus.APPROVED:
            return Localization_1["default"].translate('workflow_status_approved');
        case types_1.WorkflowStatus.ARCHIVED:
            return Localization_1["default"].translate('workflow_status_archived');
        case types_1.WorkflowStatus.DECLINED:
            return Localization_1["default"].translate('workflow_status_declined');
        case types_1.WorkflowStatus.DONE:
            return Localization_1["default"].translate('workflow_status_done');
        case types_1.WorkflowStatus.NEW:
            return Localization_1["default"].translate('workflow_status_new');
        case types_1.WorkflowStatus.PENDING:
            return Localization_1["default"].translate('workflow_status_pending');
        default:
            return Localization_1["default"].translate('status_missing');
    }
};
exports.getStatusTranslation = getStatusTranslation;
